(function () {
    'use strict';

    angular
        .module('app.alerts')
        .controller('AlertsListController', AlertsListController);

    AlertsListController.$inject = ['common', 'dataservice', 'bootstrap.dialog', 'config'];
    /* @ngInject */
    function AlertsListController(common, dataservice, bsDialog, config) {
        var vm = this;

        vm.title = 'Alerts';
        vm.displayedItems = [];
        vm.items = [];
        vm.refresh = refresh;
        vm.showItemDetails = showItemDetails;

        vm.toDate = new Date();
        vm.fromDate = moment().add(-30, 'days').toDate();
        vm.getItems = getItems;


        activate();

        function activate() {
            var promises = [getItems()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
                common.notifier.notify(config.events.refreshCounts);
            }, function (error) { });
        }

        function getItems() {

            var f = moment(vm.fromDate).format("YYYYMMDD");
            var t = moment(vm.toDate).format("YYYYMMDD");


            return dataservice.getItems('api/Alerts/GetForRange/' + f + '/' + t).then(function (response) {
                vm.items = response.data;
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }

        function showItemDetails(i) {
            return bsDialog.htmlBodyDialog(i.Title, i.Description);
        }

        function refresh() {
            getItems();
        }
    }
})();
